import { get, push, ref, remove, set, update } from "firebase/database";
import { db } from "./Firebase";

// Helper function to check if Firebase is initialized
const checkFirebaseInit = () => {
  if (!db) {
    throw new Error('Firebase is not initialized. Please check your .env configuration.');
  }
};

export const pushRequest = async (request) => {
  checkFirebaseInit();
  const r = push(ref(db, "requests"));
  await set(r, { ...request, status: "pending", createdAt: Date.now() });
  return r.key;
};

export const fetchRequestsRef = () => {
  checkFirebaseInit();
  return ref(db, "requests");
};

export const updateRequest = async (id, updateObj) => {
  checkFirebaseInit();
  await update(ref(db, `requests/${id}`), { ...updateObj, handledAt: Date.now() });
};

export const deleteRequest = async (id) => {
  checkFirebaseInit();
  await remove(ref(db, `requests/${id}`));
};

export const deleteFamily = async (regId) => {
  checkFirebaseInit();
  await remove(ref(db, `registration/${regId}`));
};

export const deleteMember = async (regId, memberKey) => {
  checkFirebaseInit();
  await remove(ref(db, `registration/${regId}/members/${memberKey}`));
};

export const moveMember = async (fromRegId, memberKey, toRegId) => {
  checkFirebaseInit();
  const snap = await get(ref(db, `registration/${fromRegId}/members/${memberKey}`));
  if (!snap.exists()) throw new Error("सदस्य नहीं मिला");
  const data = snap.val();
  const newRef = push(ref(db, `registration/${toRegId}/members`));
  await set(newRef, data);
  await remove(ref(db, `registration/${fromRegId}/members/${memberKey}`));
  return newRef.key;
};
